<div class="widget-container">

    @if (!!widgetType && !!widgetSourceId) {
        <div [id]="widgetSourceId" [class]="widgetClass">

            @switch (widgetType) {
                @case ('control-set') {
                    <widget-control-set [widgetSourceId]="widgetSourceId"
                                        [ignoreDisplayRule]="ignoreDisplayRule"
                                        [variableReceiver]="variableReceiver"
                                        [variableEmitter]="variableEmitter"
                                        [staticVariables]="staticVariables"
                                        [exportable]="exportable"
                                        [output]="output">
                    </widget-control-set>
                }
                @case ('table') {
                    <widget-grid [widgetSourceId]="widgetSourceId"
                                 [ignoreDisplayRule]="ignoreDisplayRule"
                                 [variableReceiver]="variableReceiver"
                                 [variableEmitter]="variableEmitter"
                                 [staticVariables]="staticVariables"
                                 [exportable]="exportable"
                                 [output]="output">
                    </widget-grid>
                }
                @case ('chart') {
                    <widget-chart [widgetSourceId]="widgetSourceId"
                                  [ignoreDisplayRule]="ignoreDisplayRule"
                                  [variableReceiver]="variableReceiver"
                                  [staticVariables]="staticVariables"
                                  [exportable]="exportable"
                                  [output]="output">
                    </widget-chart>
                }
                @case ('html') {
                    <widget-html [widgetSourceId]="widgetSourceId"
                                 [ignoreDisplayRule]="ignoreDisplayRule"
                                 [variableReceiver]="variableReceiver"
                                 [staticVariables]="staticVariables"
                                 [exportable]="exportable"
                                 [output]="output">
                    </widget-html>
                }
            }

        </div>
    }
</div>